export default __webpack_public_path__ + "static/media/GMR_Connect_Portal.0b226787.pdf";